/**
 * @desc 根据国家二字码和洲（省）编号查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.BaseStateResponseDto>;
export function request(secondWord: string, stateCode: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/baseState/bySecondWordAndCode/${secondWord}/${stateCode}`, {
      method: "GET",

      ...options,
    }),
  );
}
